var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Filter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M7.5,18a.5.5,0,0,1-.224-.053A.5.5,0,0,1,7,17.5V10.83A2.013,2.013,0,0,0,6.41,9.41L.59,3.59A2.017,2.017,0,0,1,0,2.17V1A1,1,0,0,1,1,0H17a1,1,0,0,1,1,1V2.17a2.017,2.017,0,0,1-.59,1.42L11.59,9.41A2.013,2.013,0,0,0,11,10.83V14.5a2.01,2.01,0,0,1-.8,1.6L7.8,17.9A.5.5,0,0,1,7.5,18ZM2,2v.17L4.83,5H13.17L16,2.17V2Z",
    transform: "translate(3 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Filter);
export default __webpack_public_path__ + "static/media/icon-24-filter.ca42ac2778e7beb33a69e3ccadc43200.svg";
export { ForwardRef as ReactComponent };